// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1y6m{justify-content:flex-start}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._2lx21bp4{flex-direction:column}", ""]);
// Exports
module.exports = exports;
